import { resolveSentryBookingRouteContext } from "./sentry-booking-route-context.js";
import { normalizeRouteTemplate } from "./normalize-route-template.js";
import { resolveSentryRouteTemplate } from "./resolve-sentry-route-template.js";
import { setSentryTag } from "./set-sentry-tag.js";
import { setSentryUrlAttribute } from "./sentry-url-attribute.js";

export const syncSentryRouteContext = ({
  pathname,
  search,
  url,
}: {
  pathname: string;
  search: string;
  url: string;
}): void => {
  setSentryUrlAttribute(url);

  const { hotelId, checkoutId, dealKey } = resolveSentryBookingRouteContext({ pathname, search });

  setSentryTag("routeTemplate", normalizeRouteTemplate(resolveSentryRouteTemplate(pathname)));
  setSentryTag("hotelId", hotelId);
  setSentryTag("checkoutId", checkoutId);
  setSentryTag("dealKey", dealKey);
};
